export default function getPublisherDistributionPresets({ article, publisher }) {
	return Object.values(publisher.distribution?.presets || {}).filter((preset) => {
		return (
			!preset.disabled &&
			preset.languages.some((language) => language === article.language) &&
			preset.articleType === article.type &&
			(!preset.imprintIds?.length || preset.imprintIds.includes(article.imprint?.id))
		);
	});
}
